module.exports = __webpack_public_path__ + "img/pen.20710a90.svg";